<script setup lang="ts">
// Ported from flowconnect-dashboard/app/components/ui with explicit imports (no Nuxt auto-imports).
import { TooltipContent, TooltipPortal, TooltipRoot, TooltipTrigger } from 'reka-ui'

defineProps<{ text: string; side?: 'top' | 'bottom' | 'left' | 'right' }>()
</script>

<template>
  <TooltipRoot :delay-duration="250">
    <TooltipTrigger as-child><slot /></TooltipTrigger>
    <TooltipPortal>
      <TooltipContent
        :side="side ?? 'top'"
        :side-offset="6"
        class="anim-pop z-50 max-w-xs rounded-md bg-foreground px-2 py-1 text-xs text-background shadow-pop"
      >
        {{ text }}
      </TooltipContent>
    </TooltipPortal>
  </TooltipRoot>
</template>
